var map = {
	"./bremen/q1.mp3": 6111,
	"./bremen/q2.mp3": 4369,
	"./bremen/q3.mp3": 1716,
	"./bremen/q4.mp3": 6899,
	"./bremen/q5.mp3": 8220,
	"./correct.mp3": 8139,
	"./eisenach/dschinghis-khan.mp3": 1899,
	"./eisenach/fur-elise.mp3": 5066,
	"./eisenach/moskau.mp3": 6543,
	"./eisenach/turkischer-marsch.mp3": 6737,
	"./frankfurt/code.mp3": 9773,
	"./frankfurt/eight.mp3": 5703,
	"./frankfurt/five.mp3": 9873,
	"./frankfurt/four.mp3": 2683,
	"./frankfurt/nine.mp3": 3109,
	"./frankfurt/one.mp3": 1733,
	"./frankfurt/seven.mp3": 6546,
	"./frankfurt/six.mp3": 3219,
	"./frankfurt/three.mp3": 4800,
	"./frankfurt/two.mp3": 8706,
	"./frankfurt/zero.mp3": 4222,
	"./game_songs.mp3": 9345,
	"./incorrect.mp3": 1012,
	"./stuttgart/back.mp3": 6242,
	"./stuttgart/front.mp3": 9013,
	"./stuttgart/left.mp3": 9226,
	"./stuttgart/right.mp3": 1485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9403;